import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { ProTip } from '@calendly/ui/components/pro-tip'
import { BodyText } from '@calendly/ui/components/typography'

import { UrlField } from 'components/event_type_edit'

import { useErrorAfterInitialTouch } from '../../hooks'
import { HeaderWithIcon, PanelContentContainer } from '../styles'
import { PassBookingDetailsField } from './pass_booking_details_field'

export const ExternalSection = () => {
  const urlFieldName = 'redirectConfigurationUrl'

  useErrorAfterInitialTouch(urlFieldName)

  return (
    <PanelContentContainer subsection>
      <HeaderWithIcon>
        <BodyText size="medium" weight="bold">
          {I18n.t('publisher.event_types.confirmation_page.labels.redirect_url')}
        </BodyText>
        <ProTip>
          {HtmlParser(I18n.t('publisher.event_types.confirmation_page.labels.redirect_url_tip'))}
        </ProTip>
      </HeaderWithIcon>
      <UrlField
        autoFocus
        aria-label={I18n.t('publisher.event_types.confirmation_page.labels.redirect_url')}
        name={urlFieldName}
      />
      <PassBookingDetailsField />
    </PanelContentContainer>
  )
}
